if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        console.log('ProductForm')
        this.form = this.querySelector('form');
        console.log('this.form')
        console.log(this)
        if (!this.form) return;

        if (this.form.querySelector('[name=id]')) {
          this.form.querySelector('[name=id]').disabled = false;
        }

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.sizeSwatch = this.querySelectorAll('input[data-quick-add="true"]');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        if (this.sizeSwatch) {
          this.sizeSwatch.forEach((el) => {
            el.addEventListener('click', () => setTimeout(() => this.submitButton.click(), 1000));
          });
        }
      }

      onSubmitHandler(evt) {
        console.log('onSubmitHandler')
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').removeAttribute('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const formDataValues = [...formData.entries()];

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {

          console.log('response.status-----------')
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            this.cart.renderContents(response);
            console.log(response);
            this.submitButton.querySelector('span').textContent = 'Added to Cart';
            if (this.closest('.product-card')) {
              this.closest('.product-card').classList.add('item-added');
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally((response) => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').setAttribute('hidden', '');
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

[...document.getElementsByClassName('product-option-size')].forEach( opt => {
  opt.addEventListener('click', e => {
    setTimeout(()=> {
      let vid = document.getElementsByClassName('product-details-variants')[0].querySelector('input[name="id"]:checked').value;
      document.getElementsByClassName('single-product--form')[0].querySelector('input[name="id"]').value = vid;
    }, 100)
    console.log('size option clicked')
    if(!opt.classList.contains('sold-out')) {
      console.log('sold out false')
      //document.getElementById('AddToCartButton').removeAttribute('disabled');
      document.getElementById('AddToCartButton').disabled = false;
      document.getElementById('AddToCartButton').classList.remove('disabled');
      //document.getElementsByClassName('product-form__submit')[0].classList.remove('disabled');
    } else {
      console.log('sold out true')
      //document.getElementById('AddToCartButton').setAttribute('disabled');
      document.getElementById('AddToCartButton').disabled = true;
      document.getElementById('AddToCartButton').classList.add('disabled');
      //document.getElementsByClassName('product-form__submit')[0].classList.add('disabled');
    }
    $(".purchase-section").find("button.product-option-selector.active").trigger("click");
  })
})